export type Measurement = {
    Id: string;
    ActualValue: number;
    [key: string]: any; // Extend as needed
};

export const standardMeasurementData = [
    {
        name: "Area",
        total: "-",
        actual: "",
        unit: "sqft",
        description: "Total surface area of the roof",
    },
    {
        name: "Ridge",
        total: "-",
        actual: "",
        unit: "ft",
        description: "Horizontal peak line where two roof slopes meet",
    },
    {
        name: "Hip",
        total: "-",
        actual: "",
        unit: "ft",
        description: "Sloped edge where two roof sections meet",
    },
    {
        name: "Valley",
        total: "-",
        actual: "",
        unit: "ft",
        description: "Internal angle formed where two slopes meet",
    },
    {
        name: "Eave",
        total: "-",
        actual: "",
        unit: "ft",
        description: "Lower edge of the roof that overhangs the wall",
    },
    {
        name: "Rake",
        total: "-",
        actual: "",
        unit: "ft",
        description: "Sloped edge from eave to ridge on gable ends",
    },
    {
        name: "Step Flashing",
        total: "-",
        actual: "",
        unit: "ft",
        description: "Flashing used where roof meets a vertical wall",
    },
    {
        name: "Counter Flashing",
        total: "-",
        actual: "",
        unit: "ft",
        description: "Protective flashing installed over step flashing",
    },
];
